import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { links } from '../enums';

const AutoDownload = () => {
  const navigator = useNavigate();
  useEffect(() => {
    const link = document.createElement('a');
    link.href = '/mobile_portfolio.pdf';
    link.setAttribute(
      'download',
      'mobile_portfolio.pdf',
    );

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode?.removeChild(link);
    navigator({ pathname: links.main });
  }, []);
  return null;
};

export default AutoDownload;
